import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ContentLoader } from '@saucelabs/sl-component-loader';
import { records as userRecords } from '@saucelabs/sl-module-user';

import * as operations from './../operations';
import ApplicationContentWithLaunchDarkly from './ApplicationContentWithLaunchDarkly';

class Application extends Component {
  componentDidMount() {
    const { initialize, postInitialize } = this.props;
    initialize().then(() => {
      postInitialize();
    });
  }

  componentWillUnmount() {
    const { stop } = this.props;
    stop();
  }

  render() {
    const { children, initialized, user, errorCode, cordAuthToken } = this.props;
    const appInitialized = initialized && user;

    return (
      <ContentLoader show={!appInitialized && !errorCode}>
        <ApplicationContentWithLaunchDarkly
          cordAuthToken={cordAuthToken}
          user={user}
        >
          {children}
        </ApplicationContentWithLaunchDarkly>
      </ContentLoader>
    );
  }
}

Application.defaultProps = {
  cordAuthToken: undefined,
  errorCode: undefined,
  user: null,
};

Application.propTypes = {
  children: PropTypes.node.isRequired,
  cordAuthToken: PropTypes.string,
  errorCode: PropTypes.number,
  initialize: PropTypes.func.isRequired,
  initialized: PropTypes.bool.isRequired,
  postInitialize: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass),
};

const mapStateToProps = ({ apps: { app }, user, errorPage }) => ({
  cordAuthToken: app.get('cordToken'),
  errorCode: errorPage.status,
  initialized: app.get('initialized'),
  user,
});

const mapDispatchToProps = {
  initialize: operations.initialize,
  postInitialize: operations.postInitialize,
  stop: operations.stop,
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Application));
export { Application, mapStateToProps, mapDispatchToProps };
